import { makeStylesheetLink } from "@self/stylesheet";

export class EditCheckoutStep extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" className="gct-btn-sm gct-btn-tertiary">EDIT</button> as HTMLButtonElement;
		this.onClick = onClick.bind(this);

		this.shadow.append(this.button, makeStylesheetLink());
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: EditCheckoutStep) {
	try {
		this.button.disabled = true;

		const currentTab = document.getElementById("panel-review");
		const destTab = document.getElementById(this.dataset.destTab!);

		if (currentTab && destTab) {
			currentTab.classList.add("gct-d-none");
			destTab.classList.remove("gct-d-none");
		}

		const reviewTab = document.getElementById("btn-review");
		if (reviewTab) reviewTab.classList.remove("gct-checkout-tab");
		const activeTab = document.getElementById(this.dataset.destLink!);
		if (activeTab) activeTab.classList.add("gct-checkout-tab");

	} finally {
		this.button.disabled = false;
	}
}
